
















import { FaturamentoDiario } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import ChartLine from "@/shared/components/chart-line.vue";
import { title, ticks } from '@/shared/utils/chart';

interface PlanoDiario {
  data: any;
  qtd: number | null;
  qtdMesPassado: number;
}

@Component({ components: { ChartLine } })
export default class GraficoPlanoDiario extends Vue {
  //Atributos
  //Opções do gráfico
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index", //Para mostrar todos os datasets pelo indice no eixo y,
      callbacks: {
        //Callback para montar o titulo do tooltip
        title: title(),
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            precision: 0, //Precisão 0 indica somente números inteiros
            beginAtZero: true, //Para iniciar no 0 caso mês tenha nehum dado
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            callback: ticks(),
          },
        },
      ],
    },
  };
  processado = true;
  dataQuantidade: PlanoDiario[] = [];
  //Fim Atributos

  //Props
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly value!: FaturamentoDiario[];
  //Fim Props

  //Computed
  get labels() {
    return this.dataQuantidade.map((x) => x.data);
  }
  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        lineTension: 0,
        label: "Quantidade",
        backgroundColor: "#3e95cd",
        data: this.dataQuantidade.map((x) => x.qtd),
      },
      {
        lineTension: 0,
        label: "Mês passado",
        backgroundColor: "#cecece",
        data: this.dataQuantidade.map((x) => x.qtdMesPassado),
      },
    ];
  }
  //Fim Computed

  mounted() {
    this.onValueChange(this.value);
  }

  @Watch("value")
  onValueChange(val: FaturamentoDiario[]) {
    this.processado = false;
    this.dataQuantidade = [];
    if (val) {
      try {
        for (let i = 0; i < val.length; i++) {
          const item = val[i];
          const dataJson = new Date(parseInt(item.data.substr(6)));

          let qtdAnterior = 0;
          let qtdAnteriorMesPassado = 0;

          if (i > 0) {
            qtdAnterior = this.dataQuantidade[i - 1].qtd ?? 0;
            qtdAnteriorMesPassado = this.dataQuantidade[i - 1].qtdMesPassado;
          }

          this.dataQuantidade.push({
            data: item.data,
            qtd: dataJson > new Date() ? null : qtdAnterior + item.qtd,
            qtdMesPassado: qtdAnteriorMesPassado + item.qtdMesPassado,
          });
        }
      } finally {
        this.processado = true;
      }
    }
  }
}
